// Card names are stored mixed-case or ALL-CAPS. An ALL-CAPS name is shown in
// title case ("THE UNSEEN DAP" -> "The Unseen Dap"); mixed-case names render
// exactly as stored. Kept upper: tokens with digits (3AM, F1), no-vowel
// abbreviations (MD, DJ, TV), roman numerals and a few known acronyms.
const KEEP_CAPS = new Set(['RKO', 'NYC', 'USA', 'UK', 'CEO', 'VIP', 'AI', 'OK', 'MC', 'NFT', 'DNA', 'ATM', 'BBQ', 'GOAT', 'OG', 'UFO', 'HQ', 'IQ', 'PR', 'LA', 'NY', 'SF', 'NBA', 'NFL']);
const SMALL_WORDS = new Set(['a', 'an', 'and', 'as', 'at', 'by', 'for', 'in', 'of', 'on', 'or', 'the', 'to', 'vs']);
export function displayName(name) {
  if (!name || name !== name.toUpperCase() || !/[A-Z]/.test(name)) return name;
  let first = true;
  return name.replace(/[A-Z0-9][A-Z0-9'’.]*/g, (w) => {
    const bare = w.replace(/[^A-Z0-9]/g, '');
    const lead = first; first = false;
    if (/\d/.test(bare) || KEEP_CAPS.has(bare) || /^(?:I{1,3}|IV|VI{0,3}|IX|XI{0,3})$/.test(bare)
      || (bare.length <= 3 && !/[AEIOUY]/.test(bare) && bare !== 'DR' && bare !== 'MR' && bare !== 'MS')) return w;
    if (bare === 'TEDX') return w.replace('TEDX', 'TEDx');
    const lw = w.toLowerCase();
    if (!lead && SMALL_WORDS.has(lw)) return lw;
    return lw[0].toUpperCase() + lw.slice(1);
  });
}
